import { render, staticRenderFns } from "./TagsPage.vue?vue&type=template&id=01f8c3fa&scoped=true"
import script from "./TagsPage.vue?vue&type=script&lang=js"
export * from "./TagsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8c3fa",
  null
  
)

export default component.exports